import * as actionTypes from "./actionTypes";
import axios from "../../axios-common";
import axiosRequest from "../../axios-request/request.methods";
import { stoageGetter } from "../../helpers";

const user_data = stoageGetter("user");
let loginUserID = user_data?.id;

// Fetch leads data
export const fetchStateStart = () => {
  return {
    type: actionTypes.FETCH_STATES_START,
  };
};

export const fetchStateSuccess = (states) => {
  return {
    type: actionTypes.FETCH_STATES_SUCCESS,
    states: states,
  };
};

export const fetchStateFail = (error) => {
  return {
    type: actionTypes.FETCH_STATES_FAIL,
    error: error,
  };
};

export const fetchAllState = (leads, pageNo) => {
  return (dispatch) => {
    dispatch(fetchStateStart());
    return axiosRequest
      .get(`user/get_allState`)
      .then((res) => {
        // //console.log("Response:::", res);
        return dispatch(fetchStateSuccess(res?.stateData));
      })
      .catch((error) => {
        return dispatch(fetchStateFail(error));
      });
  };
};

export const fetchCitiesStart = () => {
  return {
    type: actionTypes.FETCH_CITIES_START,
  };
};

export const fetchCitiesSuccess = (cities) => {
  // //console.log("cities===>", cities);
  return {
    type: actionTypes.FETCH_CITIES_SUCCESS,
    cities: cities,
  };
};

export const fetchCitiesFail = (error) => {
  return {
    type: actionTypes.FETCH_CITIES_FAIL,
    error: error,
  };
};

export const fetchAllCities = () => {
  // //console.log("statecode ", stateCode);
  return (dispatch) => {
    dispatch(fetchCitiesStart());
    return axiosRequest
      .get(`user/get_allCities`)
      .then((res) => {
        // //console.log("City Response==>", res);
        // //console.log(res.data.errMsg[1][0].count)
        // if(res.data.errCode===-1){

        return dispatch(fetchCitiesSuccess(res?.cityData));
        // }
      })
      .catch((error) => {
        return dispatch(fetchCitiesFail(error));
      });
  };
};

//fetch countries
export const fetchCountryStart = () => {
  return {
    type: actionTypes.FETCH_COUNTRY_START,
  };
};

export const fetchCountrySuccess = (countries) => {
  // //console.log("countries",countries);
  return {
    type: actionTypes.FETCH_COUNTRY_SUCCESS,
    countries: countries,
  };
};

export const fetchCountryFail = (error) => {
  return {
    type: actionTypes.FETCH_COUNTRY_FAIL,
    error: error,
  };
};

export const fetchAllCountry = (leads, pageNo) => {
  // //console.log("fetchAllCountry");
  return (dispatch) => {
    dispatch(fetchCountryStart());
    return axiosRequest 
      .get(`user/get_allContries`)
      .then((res) => {
        // //console.log("Response:::", res);
        return dispatch(fetchCountrySuccess(res?.ContryData));
      })
      .catch((error) => {
        return dispatch(fetchCountryFail(error));
      });
  };
};